import { Component } from '@angular/core';

@Component({
  selector: 'app-relevant-authors',
  templateUrl: './relevant-authors.component.html',
  styleUrls: ['./relevant-authors.component.css'],
})
export class RelevantAuthorsComponent {}
